import { PayloadAction } from "@reduxjs/toolkit";
import { IActivityHistoryUpFilter, isUpFilter } from "../../model";

export function addUpFiltersReducer(state, action: PayloadAction<IActivityHistoryUpFilter>) {
  const index = state.filters.findIndex(isUpFilter);

  if (index === -1) {
    state.filters.push(action.payload);
  } else {
    const existing = state.filters[index];

    const mergedValues = [
      ...existing.values,
      ...action.payload.values.filter((v) => !existing.values.some((ev) => ev.value === v.value)),
    ];

    state.filters[index] = {
      ...existing,
      values: mergedValues,
    };
  }
}
